module.exports = __webpack_public_path__ + "static/media/defalut.55f53ee4.svg";